var $9aebf53181a474bd$exports = {};
$9aebf53181a474bd$exports = {
  "rangeOverflow": function rangeOverflow(args) {
    return "\u503C\u5FC5\u9808\u662F ".concat(args.maxValue, " \u6216\u66F4\u65E9\u3002");
  },
  "rangeReversed": "\u958B\u59CB\u65E5\u671F\u5FC5\u9808\u5728\u7D50\u675F\u65E5\u671F\u4E4B\u524D\u3002",
  "rangeUnderflow": function rangeUnderflow(args) {
    return "\u503C\u5FC5\u9808\u662F ".concat(args.minValue, " \u6216\u66F4\u665A\u3002");
  },
  "unavailableDate": "\u6240\u9078\u65E5\u671F\u7121\u6CD5\u4F7F\u7528\u3002"
};
export { $9aebf53181a474bd$exports as default };